import React from 'react';
import RoleFormPage from './RoleFormPage';

const RoleCreatePage: React.FC = () => <RoleFormPage mode="create" />;

export default RoleCreatePage;
